export function thousands(value) {
    if (!value) return 0
    var regNum = /^[0-9]*$/;
    if(!regNum.test(value))
      return value;
    // 获取整数部分
    const intPart = Math.trunc(value)
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 预定义小数部分
    let floatPart = ''
    // 将数值截取为小数部分和整数部分
    const valueArray = value.toString().split('.')
    if (valueArray.length === 2) { // 有小数部分
      floatPart = valueArray[1].toString() // 取得小数部分
      return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
  }

export function isWxWork() {
  // var ua = window.navigator.userAgent.toLowerCase();
  // if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
  //   return true;
  // }else {
  //   return false;
  // }
  return true;
}

export function judgeClient() {
  let ua = navigator.userAgent.toLowerCase();
  //android终端
  let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; 
  //ios终端
  let isiOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/);
  if(isAndroid) {
    return 'Android';
  } else if(isiOS) {
    return 'ios';
  }else {
    return '';
  }
}
  